var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "14px",
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEdit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.2911621,3.09064012 L10.8850838,3.49671841 L9.25861064,1.87024527 L9.66468893,1.46416698 C10.0988471,1.03000881 10.8570039,1.03000881 11.2911621,1.46416698 C11.5082411,1.68124606 11.6281206,1.96960485 11.6281206,2.27740355 C11.6281206,2.58520225 11.5082411,2.87356103 11.2911621,3.09064012 Z M3.69015413,10.692728 L1.52152328,11.2348858 L2.06368099,9.06625491 L8.44537407,2.68456183 L10.0718472,4.31103497 L3.69015413,10.692728 Z M12.1043986,0.652010407 C11.2360823,-0.217385925 9.72084869,-0.217385925 8.85145236,0.652010407 L1.1370449,8.36641786 C1.06360521,8.43985755 1.01068544,8.53273716 0.98584554,8.63317674 L0.173688967,11.885043 C0.125089172,12.0805222 0.18232893,12.2878813 0.324888329,12.4315207 C0.433967869,12.5406003 0.580847249,12.6 0.730966616,12.6 C0.77740642,12.6 0.823846224,12.5946 0.870286028,12.5827201 L4.1232323,11.7694835 C4.22475188,11.7446436 4.31655149,11.6917238 4.38999118,11.6182841 L12.1043986,3.90387669 C12.5385568,3.46971852 12.7783158,2.89192096 12.7783158,2.27740355 C12.7783158,1.66288614 12.5396368,1.08616858 12.1043986,0.652010407 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter",
    transform: "translate(-342.000000, -386.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(17.000000, 385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(172.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/right-arrow",
    transform: "translate(159.000000, 8.000000) rotate(-360.000000) translate(-159.000000, -8.000000) translate(152.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icEdit",
    transform: "translate(0.840000, 0.560000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#CCCCCC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/light-green",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.120000, -0.840000)",
    id: "colour/mid-grey"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 14.56,
    height: 14.56
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/icEdit.85c482e2adeeb538ecf9ad1a10974ed3.svg";
export { ForwardRef as ReactComponent };